<template>
  <WebTop />
  <div id="body-wrap">

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">投诉举报</b>
  </div>

  <div class="com-detail-wrap">
    <Typography>
      <Title :level="4">{{ apply.title }}</Title>
      <Paragraph v-html="apply.content"></Paragraph>

      <Title :level="4">{{ apply.statusTxt }}</Title>
      <Paragraph v-if="apply.replies!=null">
          <pre v-for="item in apply.replies" :key="item.id">{{ item.remark }}</pre>
      </Paragraph>
    </Typography>
  </div>
</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      user: null,
      page: 1,
      num: 0,
      apply: {}
    }
  },
  mounted() {
    this.initUser()
    this.initMineDetail()
  },
  methods: {
    //初始化用户信息
    initUser() {
      let userStr = localStorage.getItem("user")
      if(userStr!=null) {
        this.user = JSON.parse(userStr)
      } else {
        this.$router.push({path: '/'})
      }
    },

    initMineDetail () {
      let vm = this
      let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/complaint/v1.0/apply/detail',
        data: {
          userId: vm.user.userId,
          id: id
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          vm.apply = response.data.data
        }
      });
    },
  }
}
</script>
